import React from "react";
import styled from "styled-components";

export default ({ duration, current, original }) => (
  <Wrap className="tc">
    <div>${current.toFixed(2)}</div>
    {original && (
      <div className="f6 fw2">
        instead of <div className="dib  strike"> ${original}</div>
      </div>
    )}
  </Wrap>
);

const Wrap = styled.div`
  font-size: 21px;
  color: #333333;
  font-family: CircularStd-Book, sans-serif;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/Rate.js